export default __webpack_public_path__ + "static/media/Terminos-y-condiciones-edify-2021.b50bf2f0.pdf";